export default "__VITE_ASSET__D3QGDO1S__"